/** Parámetros fijos por normativa de "indicadores globales" (no vienen de la BD), por número de indicador. */
export const PARAMETROS_INDICADORES_GLOBALES: { [numero: string]: string | number } = {
  '1.1': 0.05,
  '1.2': 0.1,
  '1.3': 'Menor o igual al 10% por el grupo de desarrolladores de 5% por cada desarrollador',
  '2.1': 'Igual o mayor al 100%',
  '2.2': 'Menor o igual al 12%',
  '2.3': 'Menor o igual al 15%',
  '3.1': 'No menor del 10% CACS abiertas; no menor del 5% CACS cerradas; y no menor del 8% federaciones',
  '3.2': 'Menor al 80%',
  '3.3': 'Igual o Mayor al 20%',
  '4.1': 'Igual o mayor al 9% Según lo establezca BCH',
  '4.2': 'Igual o mayor al 24% Según lo establezca BCH',
  '4.3': 'Mínimo el 110%',
  '5.1': 'Mayor o igual al 110%',
  '5.2': 'Menor al 15%',
  '6.1': 'Mayor o igual al 0.50%',
};

/** Un tramo de calificación: si `cumple(resultado)` es true, el indicador queda en esa
 * letra/puntaje. E siempre es el tramo por defecto (sin `cumple`). */
export interface TramoIndicadorGlobal {
  letra: string;
  puntaje: number;
  cumple?: (v: number) => boolean;
}

/** Tabla de tramos por indicador, en escala de porcentaje (5 = 5%). Basada en
 * ind_financieros!AA:AE. Nota: 4.1 tramo E y 6.1 tramo D parecían errores de captura
 * en el original (72%/3%), se corrigieron a 7.2%/0.3%. 1.3 tiene un hueco entre
 * 13% y 14% que cae en el tramo E por defecto. */
export const REGLAS_RANGO_INDICADORES_GLOBALES: { [numero: string]: TramoIndicadorGlobal[] } = {
  '1.1': [
    { letra: 'A', puntaje: 4, cumple: v => v < 5 },
    { letra: 'B', puntaje: 3, cumple: v => v >= 5 && v < 6 },
    { letra: 'C', puntaje: 2, cumple: v => v >= 6 && v < 7 },
    { letra: 'D', puntaje: 1, cumple: v => v >= 7 && v < 8 },
    { letra: 'E', puntaje: 0 },
  ],
  '1.2': [
    { letra: 'A', puntaje: 3, cumple: v => v <= 7.5 },
    { letra: 'B', puntaje: 2.25, cumple: v => v > 7.5 && v < 8.5 },
    { letra: 'C', puntaje: 1.5, cumple: v => v >= 8.5 && v < 9.5 },
    { letra: 'D', puntaje: 0.75, cumple: v => v >= 9.5 && v < 10.5 },
    { letra: 'E', puntaje: 0 },
  ],
  '1.3': [
    { letra: 'A', puntaje: 3, cumple: v => v <= 10 },
    { letra: 'B', puntaje: 2.25, cumple: v => v > 10 && v < 12 },
    { letra: 'C', puntaje: 1.5, cumple: v => v >= 12 && v < 13 },
    { letra: 'D', puntaje: 0.75, cumple: v => v >= 14 && v < 16 },
    { letra: 'E', puntaje: 0 },
  ],
  '2.1': [
    { letra: 'A', puntaje: 8, cumple: v => v >= 100 },
    { letra: 'B', puntaje: 6, cumple: v => v >= 80 && v < 100 },
    { letra: 'C', puntaje: 4, cumple: v => v >= 60 && v < 80 },
    { letra: 'D', puntaje: 2, cumple: v => v >= 40 && v < 60 },
    { letra: 'E', puntaje: 0 },
  ],
  '2.2': [
    { letra: 'A', puntaje: 8, cumple: v => v < 12 },
    { letra: 'B', puntaje: 6, cumple: v => v >= 12 && v < 13 },
    { letra: 'C', puntaje: 4, cumple: v => v >= 13 && v < 14 },
    { letra: 'D', puntaje: 2, cumple: v => v >= 14 && v < 15 },
    { letra: 'E', puntaje: 0 },
  ],
  '2.3': [
    { letra: 'A', puntaje: 4, cumple: v => v <= 15 },
    { letra: 'B', puntaje: 3, cumple: v => v > 15 && v < 17 },
    { letra: 'C', puntaje: 2, cumple: v => v >= 17 && v < 19 },
    { letra: 'D', puntaje: 1, cumple: v => v >= 19 && v < 21 },
    { letra: 'E', puntaje: 0 },
  ],
  '3.1': [
    { letra: 'A', puntaje: 15, cumple: v => v >= 10 },
    { letra: 'B', puntaje: 11.25, cumple: v => v > 8 && v < 10 },
    { letra: 'C', puntaje: 7.5, cumple: v => v > 6 && v <= 8 },
    { letra: 'D', puntaje: 3.75, cumple: v => v > 4 && v <= 6 },
    { letra: 'E', puntaje: 0 },
  ],
  '3.2': [
    { letra: 'A', puntaje: 5, cumple: v => v < 80 },
    { letra: 'B', puntaje: 3.75, cumple: v => v >= 80 && v < 85 },
    { letra: 'C', puntaje: 2.5, cumple: v => v >= 85 && v < 90 },
    { letra: 'D', puntaje: 1.25, cumple: v => v >= 90 && v < 100 },
    { letra: 'E', puntaje: 0 },
  ],
  '3.3': [
    { letra: 'A', puntaje: 10, cumple: v => v >= 20 },
    { letra: 'B', puntaje: 7.5, cumple: v => v >= 18 && v < 20 },
    { letra: 'C', puntaje: 5, cumple: v => v >= 16 && v < 18 },
    { letra: 'D', puntaje: 2.5, cumple: v => v > 12 && v < 16 },
    { letra: 'E', puntaje: 0 },
  ],
  '4.1': [
    { letra: 'A', puntaje: 6, cumple: v => v >= 9 },
    { letra: 'B', puntaje: 4.5, cumple: v => v >= 8.1 && v < 9 },
    { letra: 'C', puntaje: 3, cumple: v => v >= 7.65 && v < 8.1 },
    { letra: 'D', puntaje: 1.5, cumple: v => v >= 7.2 && v < 7.65 },
    { letra: 'E', puntaje: 0 },
  ],
  '4.2': [
    { letra: 'A', puntaje: 6, cumple: v => v >= 24 },
    { letra: 'B', puntaje: 4.5, cumple: v => v >= 21.6 && v < 24 },
    { letra: 'C', puntaje: 3, cumple: v => v >= 20.4 && v < 21.6 },
    { letra: 'D', puntaje: 1.5, cumple: v => v >= 19.2 && v < 20.4 },
    { letra: 'E', puntaje: 0 },
  ],
  '4.3': [
    { letra: 'A', puntaje: 8, cumple: v => v >= 110 },
    { letra: 'B', puntaje: 6, cumple: v => v > 90 && v < 110 },
    { letra: 'C', puntaje: 4, cumple: v => v >= 70 && v <= 90 },
    { letra: 'D', puntaje: 2, cumple: v => v >= 50 && v < 70 },
    { letra: 'E', puntaje: 0 },
  ],
  '5.1': [
    { letra: 'A', puntaje: 5, cumple: v => v >= 110 },
    { letra: 'B', puntaje: 3.75, cumple: v => v >= 90 && v < 110 },
    { letra: 'C', puntaje: 2.5, cumple: v => v >= 70 && v < 90 },
    { letra: 'D', puntaje: 1.25, cumple: v => v >= 50 && v < 70 },
    { letra: 'E', puntaje: 0 },
  ],
  '5.2': [
    { letra: 'A', puntaje: 5, cumple: v => v < 15 },
    { letra: 'B', puntaje: 3.75, cumple: v => v >= 15 && v < 17 },
    { letra: 'C', puntaje: 2.5, cumple: v => v >= 17 && v < 19 },
    { letra: 'D', puntaje: 1.25, cumple: v => v >= 19 && v < 21 },
    { letra: 'E', puntaje: 0 },
  ],
  '6.1': [
    { letra: 'A', puntaje: 10, cumple: v => v >= 0.5 },
    { letra: 'B', puntaje: 7.5, cumple: v => v >= 0.4 && v < 0.5 },
    { letra: 'C', puntaje: 5, cumple: v => v >= 0.3 && v < 0.4 },
    { letra: 'D', puntaje: 2.5, cumple: v => v > 0.2 && v < 0.3 },
    { letra: 'E', puntaje: 0 },
  ],
};

/** Color de fondo por letra de tramo, para la celda de RANGO. Semáforo confirmado
 * en el archivo de referencia. */
export const COLOR_RANGO_INDICADORES_GLOBALES: { [letra: string]: string } = {
  A: 'FF00B050', // verde
  B: 'FF92D050', // verde claro
  C: 'FFFFFF00', // amarillo
  D: 'FFFFC000', // naranja
  E: 'FFFF0000', // rojo
};

/** Mismo semáforo, para los 5 tramos de NIVEL DE RIESGO. */
export const COLOR_NIVEL_RIESGO: { [nivel: string]: string } = {
  'BAJO': COLOR_RANGO_INDICADORES_GLOBALES['A'],
  'MEDIO BAJO': COLOR_RANGO_INDICADORES_GLOBALES['B'],
  'MEDIO': COLOR_RANGO_INDICADORES_GLOBALES['C'],
  'MEDIO ALTO': COLOR_RANGO_INDICADORES_GLOBALES['D'],
  'ALTO': COLOR_RANGO_INDICADORES_GLOBALES['E'],
};

/** Devuelve el tramo (letra + puntaje) de un indicador según su resultado en %. */
export function calcularRangoPuntaje(numero: string, valorPct: number): { rango: string; puntaje: number } | null {
  const tramos = REGLAS_RANGO_INDICADORES_GLOBALES[numero];
  if (!tramos || !isFinite(valorPct)) return null;
  const tramo = tramos.find(t => t.cumple && t.cumple(valorPct)) ?? tramos[tramos.length - 1];
  return { rango: tramo.letra, puntaje: tramo.puntaje };
}
